import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { visualizarAlerta } from '../../../../actions/generales/act_gen01';
import styled from 'styled-components';
import { Row, ContainerCol } from '../../componentes_formulario/contenedores';   
import { existeSesion } from '../../../../funciones_globales/manejosesion';

const ContenedorIconoMsg = styled.div`
    font-size: 40px;
    display: inline-block;
    color: ${props=> props.color};
`;

const GlobalContainerAlert = styled.div`
    position: fixed;
    font-family: Arial, Helvetica, sans-serif;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(0,0,0,0.2);
    z-index: 99999;    
    -webkit-transition: opacity 400ms ease-in;
    -moz-transition: opacity 400ms ease-in;
    transition: opacity 400ms ease-in;
    pointer-events: none;    
    opacity: 1;
    pointer-events: auto;
`;

const ContainerAlert = styled.div`
    width: 500px;
    position: relative;
    margin: 10% auto;
    padding: 5px 20px 13px 20px;
    border-radius: 10px;
    background: #ffffff;
    background: -moz-linear-gradient(#ffffff, #ECECEC);
    background: -webkit-linear-gradient(#ffffff, #ECECEC);
    background: -o-linear-gradient(#ffffff, #ECECEC);
    -webkit-transition: opacity 400ms ease-in;
    -moz-transition: opacity 400ms ease-in;
    transition: opacity 400ms ease-in;
`;

const TituloAlerta = styled.h5`
    font-weight: 600;
`;

class Alerta extends React.Component {
    constructor(props, context) {
        super(props, context);  
        this.handleDismiss = this.handleDismiss.bind(this);
    }
    
    handleDismiss() {
        this.props.visualizarAlerta({ isVisible: false, tipo: '', titulo: '', mensaje: '' });
        if (!existeSesion()){
            this.props.history.push("/login");
        }
    }
  
    render() {        
            let color = '';
            let icono = '';
            let tituloDefault = '';
            let estiloBoton = '';
            let titulo = this.props.configAlerta.titulo || '';

            switch(this.props.configAlerta.tipo){                
                case 'error':
                    color = '#c9302c';
                    icono = 'fa fa-times fa-lg';
                    tituloDefault = 'Error';
                    estiloBoton = 'btn btn-danger';
                    break;
                case 'warning':
                    color = '#f0ad4e';
                    icono = 'fa fa-exclamation-triangle fa-lg';
                    tituloDefault = 'Advertencia';
                    estiloBoton = 'btn btn-warning';
                    break;
                case 'info':                    
                default:
                    color = '#5bc0de';
                    icono = 'fa fa-info-circle fa-lg';
                    tituloDefault = 'Informe';
                    estiloBoton = 'btn btn-info';
                    break;
            } 

            if (titulo===''){
                titulo=tituloDefault;
            }

            if (!this.props.configAlerta.isVisible){
                return null;
            }else{
                return (
                    <GlobalContainerAlert>
                        <ContainerAlert>                            
                            <TituloAlerta>{titulo}</TituloAlerta>
                            <Row>
                                <ContainerCol className='col-sm-2'>
                                    <ContenedorIconoMsg color={color}>
                                        <i className={icono}/>
                                    </ContenedorIconoMsg>
                                </ContainerCol>
                                <ContainerCol className='col-sm-10'>
                                    <p>{this.props.configAlerta.mensaje}</p>
                                </ContainerCol>
                            </Row>
                            <Row>
                                <ContainerCol className='col-sm-offset-9 col-sm-3'>
                                    <button className={estiloBoton} type='button' onClick={this.handleDismiss}>Aceptar</button>
                                </ContainerCol>
                            </Row>
                        </ContainerAlert>
                    </GlobalContainerAlert>
                );
            }
    }
}

const mapStateToProps = state => {
    return { configAlerta: state.ui.configAlerta };
};

const mapDispatchToProps = dispatch => {  
    return bindActionCreators({ visualizarAlerta }, dispatch)
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Alerta));